export default __webpack_public_path__ + "static/media/palaute-lightblue.a691656d.svg";